<template>
	<div>
		<div class="box">
			<div class="field">
				<p class="title">Scan</p>
			</div>
			<hr style="margin-left:25px;margin-right:25px;"/>

			<table>
	            <tr>
	                <td style="width:100%">
	                    <input id="scanText" v-on:change="scan" class="textfield" v-model="scanText" tabindex=0></input>
	                </td>
	            </tr>
	        </table>
		</div>
		<div class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_INVENTORY_PAGE,
			perms:[],
			nav_items:['Inventory List', 'Edit Inventory List', 'Scan Item'],
			nav_item_perms:['88','88','89'],
			scanText:'',
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	mounted () {
		document.getElementById("scanText").focus();
	},
	methods: {
        scan(){
			const itemVal = 'LDPAV2-'
			const boxVal = 'LDPAV2BOX-'

            if(this.scanText.substr(0,itemVal.length)==itemVal){
				this.scanText = this.scanText.substr(itemVal.length)
			}

			if(!isNaN(this.scanText) && this.scanText!=''){
				var itemId = parseInt(this.scanText)

				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid,
							term:itemId,
						}
					}
				).then((res) => {
					router.push('/0510?q='+itemId);
				});
			}
        },
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.search_term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
	margin:16px;
	font-size:24px;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}

td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/add/Add_Inventory_Item.vue